import $ from 'jquery';
import { debounce } from 'lodash';

$(document).ready(function () {
    const $emailNewsletterField = $('#newsletter-email');
    const $emailNewsletterSignup = $('#newsletter-signup');
    const $error = $('#emailSignupBlockRequired');

    $emailNewsletterSignup.click(function (event) {
        event.preventDefault();

        const $form = $(this).closest('form');

        if ($emailNewsletterField.val() != '' && validateEmail($emailNewsletterField.val())) {
            $error.removeClass('d-block');
            $emailNewsletterField.removeClass('invalid');
            window.location.href = $form.attr('action') + '?email=' + $emailNewsletterField.val();
        } else {
            $emailNewsletterField.addClass('invalid');
            $error.addClass('d-block');
        }
    });
     
    $emailNewsletterField.on('input', function (event) {
        debounceValidate();
    });

    const debounceValidate = debounce(validate, 300);

    function validate() {
        if (validateEmail($emailNewsletterField.val())) {
            $error.removeClass('d-block');
            $emailNewsletterField.removeClass('invalid');
        } else {
            $emailNewsletterField.addClass('invalid');
            $error.addClass('d-block');
        }
    }

    function validateEmail(email) {
        // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const re = /(^$)|(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;
        return re.test(String(email).toLowerCase());
    }
});